import { Directus } from '@directus/sdk';
import { API_MENU_FIELDS } from '../common/collections/model/menus/APIMenus';
import { API_MENU_TRANSLATIONS_FIELDS } from '../common/collections/model/menus/APIMenusTranslation';
import { default as APIMenuResponse } from './response/APIListMenusResponse';
export default class DirectusCmsOtherContactsApi {
    static getInstance(basePath) {
        if (!DirectusCmsOtherContactsApi.instance) {
            if (!basePath) {
                basePath = process.env.CMS_URL;
            }
            DirectusCmsOtherContactsApi.instance = new DirectusCmsOtherContactsApi();
            DirectusCmsOtherContactsApi.instance.api = new Directus(basePath);
        }
        return DirectusCmsOtherContactsApi.instance;
    }
    async listMenus(locale, requestOptions) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('menus').readByQuery(Object.assign(Object.assign({}, requestOptions), { meta: '*', sort: ['id'], fields: ['*.*.*.*', ...API_MENU_FIELDS, ...API_MENU_TRANSLATIONS_FIELDS], filter: Object.assign(Object.assign({}, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.filter), { status: 'published' }), deep: {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                translations: { _filter: { languages_id: { lang: { _eq: locale } } } },
                submenus: {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    translations: {
                        _filter: { languages_id: { lang: { _eq: locale } } }
                    }
                }
            } })));
        return new APIMenuResponse(response);
    }
    async listAllMenus(requestOptions) {
        var _a;
        const response = await ((_a = this.api) === null || _a === void 0 ? void 0 : _a.items('menus').readByQuery(Object.assign(Object.assign({}, requestOptions), { meta: '*', sort: ['id'], fields: ['*.*.*.*', ...API_MENU_FIELDS, ...API_MENU_TRANSLATIONS_FIELDS], filter: Object.assign(Object.assign({}, requestOptions === null || requestOptions === void 0 ? void 0 : requestOptions.filter), { status: 'published' }) })));
        return new APIMenuResponse(response);
    }
}
